import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  Chip,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { fetchPlayers } from '../../services/api';

const PlayersPage = () => {
  const navigate = useNavigate();
  const { data: players, isLoading, error } = useQuery(['players'], fetchPlayers);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading players</div>;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">Players</Typography>
        <Button variant="contained" startIcon={<AddIcon />}>
          Add Player
        </Button>
      </Box>

      {players && players.length > 0 ? (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Player</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>NTRP Rating</TableCell>
                <TableCell>UTR</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {players.map((player) => (
                <TableRow key={player.id} hover>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Avatar src={player.profile_image}>
                        {player.first_name[0]}{player.last_name[0]}
                      </Avatar>
                      <Box>
                        <Typography variant="body1">
                          {player.first_name} {player.last_name}
                        </Typography>
                        {player.phone && (
                          <Typography variant="body2" color="text.secondary">
                            {player.phone}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>{player.email}</TableCell>
                  <TableCell>{player.ntrp_rating || '-'}</TableCell>
                  <TableCell>{player.utr || '-'}</TableCell>
                  <TableCell>
                    <Chip
                      label={player.is_active ? 'Active' : 'Inactive'}
                      color={player.is_active ? 'success' : 'default'}
                      size="small"
                    />
                  </TableCell>
                  <TableCell>
                    <Button size="small" onClick={() => navigate(`/players/${player.id}`)}>
                      View
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            No players yet
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Add players to start managing your tennis league
          </Typography>
          <Button variant="contained" startIcon={<AddIcon />}>
            Add Player
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default PlayersPage;
